import { render, staticRenderFns } from "./ViewUserDetailsModal.vue?vue&type=template&id=379bfaab&scoped=true"
import script from "./ViewUserDetailsModal.vue?vue&type=script&lang=js"
export * from "./ViewUserDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ViewUserDetailsModal.vue?vue&type=style&index=0&id=379bfaab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379bfaab",
  null
  
)

export default component.exports